import React, { useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { useStageAtoms } from '../../../../labelling-v2/components/stage-scope/hooks';
import CanvasEditorV2 from './canvas-editor-v2';
import { filterSegmentationAnnotations } from './utils';
const CanvasEditorWithBitmaps = () => {
  const {
    annotationStoreAtom,
    currentFrameAtom,
    mlAnnotationFramesAtom,
    consensusAnnotationFramesAtom
  } = useStageAtoms();
  const annotationStore = useAtomValue(annotationStoreAtom);
  const currentFrame = useAtomValue(currentFrameAtom);
  const mlAnnotationStore = useAtomValue(mlAnnotationFramesAtom).get(currentFrame);
  const consensusAnnotationStore = useAtomValue(consensusAnnotationFramesAtom).get(currentFrame);
  const segmentationAnnotations = useMemo(() => filterSegmentationAnnotations(annotationStore, mlAnnotationStore, consensusAnnotationStore), [annotationStore, mlAnnotationStore, consensusAnnotationStore]);
  return <CanvasEditorV2 semanticAnnotations={segmentationAnnotations} />;
};
export default CanvasEditorWithBitmaps;